// client/src/coms/components/mobile/NavIcon.js
// Line icons for phone navigation ("App icons" in Mobile Layout). Drawn for Voxemera on a 24-unit grid and
// coloured with currentColor, so they follow the theme and the active state like text does.
import React from 'react';

// Each shape: a path (string), a circle ['c', cx, cy, r] or a rounded rectangle ['r', x, y, w, h, rx].
const SHAPES = {
  chats: ['M4 4.5h11a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9l-4 3.2V15H4a2 2 0 0 1-2-2V6.5a2 2 0 0 1 2-2z', 'M19.5 8.5H20a2 2 0 0 1 2 2V16a2 2 0 0 1-2 2h-1v3l-3.5-3H11'],
  servers: ['M3 10.5 12 3.5l9 7', 'M5 9v11h14V9', 'M10 20v-5.5h4V20'],
  dms: ['M21.5 3 2.5 10.6l7.2 2.7 2.7 7.2z', 'M9.7 13.3 21.5 3'],
  activities: ['M7 8.5h10a5 5 0 0 1 5 5v.5a3.2 3.2 0 0 1-5.6 2.1L14.6 14H9.4l-1.8 2.1A3.2 3.2 0 0 1 2 14v-.5a5 5 0 0 1 5-5z', 'M7.5 10.5v4M5.5 12.5h4', ['c', 16, 11.5, 0.9], ['c', 18, 13.5, 0.9]],
  chat: ['M5 9h15M4 15h15M10.5 3.5 8.5 20.5M16 3.5l-2 17'],
  watch: [['r', 2.5, 4.5, 19, 15, 3], 'M10 9v6l5-3z'],
  canvas: ['M12 3a9 9 0 1 0 0 18c1.1 0 1.6-.8 1.6-1.6 0-1-.8-1.3-.8-2.2 0-.9.7-1.6 1.6-1.6H17a4 4 0 0 0 4-4C21 6.8 17 3 12 3z', ['c', 7.5, 11, 1.2], ['c', 10, 7, 1.2], ['c', 15, 7.5, 1.2]],
  studio: ['M6 3.5v17M12 3.5v17M18 3.5v17', ['r', 4, 13, 4, 3, 1], ['r', 10, 6.5, 4, 3, 1], ['r', 16, 11, 4, 3, 1]],
  maps: ['M9 4 3 6.2v14L9 18l6 2.2 6-2.2V4l-6 2.2L9 4z', 'M9 4v14M15 6.2v14'],
  files: ['M3 7a2 2 0 0 1 2-2h4.2l2 2.2H19a2 2 0 0 1 2 2V17a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'],
  search: [['c', 10.5, 10.5, 6.5], 'M20.5 20.5 15.3 15.3'],
  members: [['c', 9, 8, 3.5], 'M2.5 20c0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5', ['c', 17.5, 9, 2.6], 'M17.5 14c2.3 0 4 1.9 4 4.6'],
  marketplace: ['M5 8h14l-1.2 12.5H6.2z', 'M9 10V6.5a3 3 0 0 1 6 0V10'],
  settings: [['c', 12, 12, 3], 'M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.3 5.3l2.1 2.1M16.6 16.6l2.1 2.1M5.3 18.7l2.1-2.1M16.6 7.4l2.1-2.1', ['c', 12, 12, 6.5]],
  profile: [['c', 12, 12, 9.5], ['c', 12, 10, 3.2], 'M6.3 18.6c1.3-2 3.3-3.1 5.7-3.1s4.4 1.1 5.7 3.1'],
  voice: ['M3.5 9.5v5h3.5l5 4v-13l-5 4z', 'M15.5 9a4 4 0 0 1 0 6M18.3 6.2a8 8 0 0 1 0 11.6'],
  more: ['M4 6.5h16M4 12h16M4 17.5h16'],
  switch: ['M7 3.5 3 7.5l4 4M3 7.5h14', 'M17 12.5l4 4-4 4M21 16.5H7'],
  back: ['M15 4.5 7.5 12l7.5 7.5'],
  close: ['M6 6l12 12M18 6 6 18'],
  up: ['M6 15l6-6 6 6'],
  down: ['M6 9l6 6 6-6'],
};

export function hasNavIcon(id) {
  return !!SHAPES[id];
}

export default function NavIcon({ id, size = 22 }) {
  const shapes = SHAPES[id] || SHAPES.more;
  return (
    <svg className="vx-navicon" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      {shapes.map((s, i) => {
        if (typeof s === 'string') return <path key={i} d={s} />;
        if (s[0] === 'c') return <circle key={i} cx={s[1]} cy={s[2]} r={s[3]} />;
        return <rect key={i} x={s[1]} y={s[2]} width={s[3]} height={s[4]} rx={s[5]} />;
      })}
    </svg>
  );
}
